export default __webpack_public_path__ + "static/media/Poster-Senna.4d1b8192.jpg";